var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rtb-stats__widget" },
    [
      _c("SmartTableWidget", {
        attrs: {
          widget: {
            tableTitle: _vm.$t("RTT_ERRORS"),
            locale: _vm.$options.i18n
          },
          "column-defs": _vm.columns,
          "row-data": _vm.errorData || [],
          "enable-date-range-filter": false,
          "enable-export": true,
          "enable-search": true,
          searchKeys: ["rttName", "rttId"],
          "search-placeholder": _vm.$t("INPUT_SEARCH_RTT_PLACEHOLDER"),
          "export-title":
            "Ring Tree Target Dispositions " +
            _vm.dateRange[0] +
            "--" +
            _vm.dateRange[1],
          "enable-popover-on-click": true,
          isLoadingTableData: _vm.isLoading,
          isLoadingPopoverData: _vm.isSearching,
          popoverData: _vm.lastErrors
        },
        on: { onClickCell: _vm.handleOnClickCell },
        scopedSlots: _vm._u([
          {
            key: "table",
            fn: function() {
              return [
                _vm.isLoading
                  ? _c("LoadingStatusDisplay")
                  : !_vm.errorData
                  ? _c("div", { staticClass: "empty-records" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("RTT_DASHBOARD_PANE_EMPTY")) +
                          "\n    "
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }